exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-72974295]:export{menu-bgc-oragne:#F2C46D}.spwwFooterPage[data-v-72974295]{color:#999;text-align:center;padding:5px 0;margin-top:10px;border-top:1px solid #e5e5e5;background-color:#f5f5f5}.spwwFooterPage .mainCont[data-v-72974295]{width:1000px;margin:0 auto}.spwwFooterPage .mainCont .footer[data-v-72974295]{color:#9E9E9E;font-size:12px}.spwwFooterPage .mainCont .footer a[data-v-72974295]{color:#9E9E9E}\n", ""]);

// exports
